// extracted by mini-css-extract-plugin
export default {"hidden":"at4lB7"};